import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { registerShape } from 'viser-vue';
registerShape('point', 'pointer', {
  draw: function draw(cfg, container) {
    var point = cfg.points[0];
    point = this.parsePoint(point);
    var center = this.parsePoint({
      x: 0,
      y: 0
    });
    container.addShape('line', {
      attrs: {
        x1: center.x,
        y1: center.y,
        x2: point.x,
        y2: point.y + 15,
        stroke: cfg.color,
        lineWidth: 5,
        lineCap: 'round'
      }
    });
    return container.addShape('circle', {
      attrs: {
        x: center.x,
        y: center.y,
        r: 9.75,
        stroke: cfg.color,
        lineWidth: 4.5,
        fill: '#fff'
      }
    });
  }
});
var scale = [{
  dataKey: 'value',
  min: 0,
  max: 9,
  tickInterval: 1,
  nice: false
}];
var data = [{
  value: 7.0
}];
export default {
  name: "DashChartDemo",
  props: {
    datasource: {
      type: Number,
      default: 7
    },
    title: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    if (!this.datasource) {
      this.chartData = data;
    } else {
      this.chartData = [{
        value: this.datasource
      }];
    }

    this.getChartData();
  },
  watch: {
    'datasource': function datasource(val) {
      this.chartData = [{
        value: val
      }];
      this.getChartData();
    }
  },
  methods: {
    getChartData: function getChartData() {
      if (this.chartData && this.chartData.length > 0) {
        this.abcd = this.chartData[0].value * 10;
      } else {
        this.abcd = 70;
      }
    },
    getHtmlGuideHtml: function getHtmlGuideHtml() {
      return '<div style="width: 300px;text-align: center;">\n' + '<p style="font-size: 14px;color: #545454;margin: 0;">' + this.title + '</p>\n' + '<p style="font-size: 36px;color: #545454;margin: 0;">' + this.abcd + '%</p>\n' + '</div>';
    },
    getArcGuide2End: function getArcGuide2End() {
      return [this.chartData[0].value, 0.945];
    }
  },
  data: function data() {
    return {
      chartData: [],
      height: 400,
      scale: scale,
      abcd: 70,
      axisLabel: {
        offset: -16,
        textStyle: {
          fontSize: 18,
          textAlign: 'center',
          textBaseline: 'middle'
        }
      },
      axisSubTickLine: {
        length: -8,
        stroke: '#fff',
        strokeOpacity: 1
      },
      axisTickLine: {
        length: -17,
        stroke: '#fff',
        strokeOpacity: 1
      },
      arcGuide1Start: [0, 0.945],
      arcGuide1End: [9, 0.945],
      arcGuide1Style: {
        stroke: '#CBCBCB',
        lineWidth: 18
      },
      arcGuide2Start: [0, 0.945],
      arcGuide2Style: {
        stroke: '#1890FF',
        lineWidth: 18
      },
      htmlGuidePosition: ['50%', '100%'],
      htmlGuideHtml: "\n      <div style=\"width: 300px;text-align: center;\">\n        <p style=\"font-size: 14px;color: #545454;margin: 0;\">".concat(this.title, "</p>\n        <p style=\"font-size: 36px;color: #545454;margin: 0;\">").concat(this.abcd, "%</p>\n      </div>\n    ")
    };
  }
};